import { VDatePicker } from 'vuetify/lib/components/VDatePicker';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDatePicker,{attrs:{"color":"secondary","no-title":"","full-width":"","locale":"jp-ja","day-format":function (date) { return new Date(date).getDate(); },"events":_vm.events},on:{"click":function($event){_vm.menu = false}},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}})}
var staticRenderFns = []

export { render, staticRenderFns }